import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export default function NewsfeedWeightsPage() {
    const [config, setConfig] = useState(null);
    const [draft, setDraft] = useState({});
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [query, setQuery] = useState('');
    const endpoint = global.config.apiDomain + '/mc-recording/web/newsfeed-weights';
    function accept(data) {
        setConfig(data);
        setDraft(Object.fromEntries(Object.entries(data.values).map(([k, v]) => [k, String(v)])));
    }
    async function load() {
        setBusy(true); setError('');
        try {
            const response = await axios.get(endpoint);
            if (response.data.status !== 'OK') throw new Error(response.data.message);
            accept(response.data.data);
        } catch (e) {
            setError((e.response && e.response.data && e.response.data.message) || e.message || 'Không tải được cấu hình.');
        } finally { setBusy(false); }
    }
    // The endpoint is fixed for the lifetime of this admin page.
    useEffect(() => { load(); }, []);
    const definitions = config ? config.definitions : [];
    const changed = definitions.filter(d => Number(draft[d.key]) !== config.values[d.key]);
    const invalid = definitions.some(d => draft[d.key] === '' || !Number.isFinite(Number(draft[d.key])) || Number(draft[d.key]) < d.min || Number(draft[d.key]) > d.max);
    async function save() {
        if (invalid || busy || !config) return;
        setBusy(true); setError('');
        try {
            const values = Object.fromEntries(definitions.map(d => [d.key, Number(draft[d.key])]));
            const response = await axios.put(endpoint, { revision: config.revision, values });
            if (response.data.status !== 'OK') throw new Error(response.data.message);
            accept(response.data.data);
            toast.success('Đã lưu. Các query newsfeed V3/V4 tiếp theo dùng weight mới.');
        } catch (e) {
            setError((e.response && e.response.data && e.response.data.message) || e.message || 'Lưu thất bại; bản chỉnh sửa vẫn được giữ.');
        } finally { setBusy(false); }
    }
    return <div id="content"><div className="container-fluid py-4">
        <h1>Trọng số Newsfeed</h1>
        <p>Quản lý điểm xếp hạng dùng chung cho API V3 và V4. Lưu để áp dụng cho các query tiếp theo, không cần khởi động lại dịch vụ.</p>
        <p className="text-muted">Các bộ lọc quyền xem, quota hiển thị và thuật toán chọn pool VIP không thay đổi tại đây.</p>
        {error && <div className="alert alert-danger" role="alert">{error}</div>}
        <div className="d-flex flex-wrap align-items-center mb-3" style={{gap: 12}}>
            <button className="btn btn-outline-secondary" disabled={busy} onClick={load}>Tải lại cấu hình</button>
            {config && <>
                <button className="btn btn-primary" disabled={busy || invalid || changed.length === 0} onClick={save}>{busy ? 'Đang xử lý…' : 'Lưu và áp dụng (' + changed.length + ')'}</button>
                <button className="btn btn-outline-secondary" disabled={busy} onClick={() => setDraft(Object.fromEntries(definitions.map(d => [d.key, String(d.defaultValue)])))}>Điền giá trị mặc định</button>
                <span className="text-muted">Bản {config.revision} · {new Date(config.updatedAt).toLocaleString()} · {config.updatedBy}</span>
            </>}
        </div>
        {busy && !config && <p role="status">Đang tải cấu hình…</p>}
        {config && <>
            <label htmlFor="weight-search">Tìm chỉ số hoặc nhóm</label>
            <input id="weight-search" className="form-control mb-3" value={query} onChange={e => setQuery(e.target.value)} placeholder="Ví dụ: Followee, GROUP_POST_BOOST" />
            {invalid && <p className="text-danger" role="alert">Điền đủ giá trị số hữu hạn trong phạm vi cho phép trước khi lưu.</p>}
            <div className="table-responsive"><table className="table table-bordered table-hover">
                <thead><tr><th>Nhóm / chỉ số</th><th>Ý nghĩa</th><th>Đang áp dụng</th><th>Giá trị mới</th><th>Mặc định</th></tr></thead>
                <tbody>{definitions.filter(d => (d.key + ' ' + d.group + ' ' + d.description).toLowerCase().includes(query.toLowerCase())).map(d => <tr key={d.key} className={Number(draft[d.key]) !== config.values[d.key] ? 'table-warning' : ''}>
                    <td><strong>{d.group}</strong><br/><code>{d.key}</code></td><td>{d.description}</td>
                    <td>{config.values[d.key]}</td>
                    <td><input aria-label={d.key} type="number" step="any" min={d.min} max={d.max} className="form-control" style={{minWidth: 160}} disabled={busy} value={draft[d.key] === undefined ? '' : draft[d.key]} onChange={e => setDraft({...draft, [d.key]: e.target.value})}/><small className="text-muted">{d.min} – {d.max}</small></td>
                    <td>{d.defaultValue}</td>
                </tr>)}</tbody>
            </table></div>
            <p className="text-muted">“Điền giá trị mặc định” chỉ sửa bản nháp. Bấm “Lưu và áp dụng” để ghi DB. “Tải lại cấu hình” bỏ bản nháp hiện tại.</p>
        </>}
    </div></div>;
}
